// extracted by mini-css-extract-plugin
export default {"img":"staticValue_img__o10mW"};